/* PasswordInput — hairline-underline password field with a built-in
   show/hide toggle. Designed to match the AdminLogin + ResetPassword
   editorial chrome (transparent bg, gold focus border, gold-accent eye
   button). Pass through any standard <input> props.

   Why this component exists: the user got locked out of production after
   mistyping their password during a hash rotation (couldn't see what they
   typed). Both the admin login form and the password-reset form now use
   this component so any password input across the admin surface can be
   peeked when needed. */
import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

export function PasswordInput({
  inputClassName = "",
  wrapperClassName = "",
  buttonClassName = "",
  "data-testid": dataTestId,
  ...inputProps
}) {
  const [show, setShow] = useState(false);
  const toggleId = dataTestId ? `${dataTestId}-toggle` : "password-toggle";
  return (
    <div className={`relative ${wrapperClassName}`}>
      <input
        {...inputProps}
        type={show ? "text" : "password"}
        data-testid={dataTestId}
        className={`${inputClassName} pr-9`}
      />
      <button
        type="button"
        onClick={() => setShow((s) => !s)}
        aria-label={show ? "Hide password" : "Show password"}
        aria-pressed={show}
        data-testid={toggleId}
        tabIndex={-1}
        className={
          `absolute right-0 bottom-2 flex items-center justify-center ` +
          `text-[color:var(--cream)]/40 hover:text-[color:var(--gold-foil)] ` +
          `focus:text-[color:var(--gold-foil)] focus:outline-none transition-colors ` +
          `${buttonClassName}`
        }
      >
        {show ? <EyeOff size={16} strokeWidth={1.4} /> : <Eye size={16} strokeWidth={1.4} />}
      </button>
    </div>
  );
}

export default PasswordInput;
